/**
 * 再資源化換算係数
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/recycle_conversion_factor_details`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      type: "industrial",
      limit: 50,
    }
  }
}

const recycle_conversion_factor_detail = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 再資源化換算係数 一覧取得
     * @param commit
     * @param condition
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ commit }, { condition, page }) {
      const params = { page: page, type: condition.type, limit: condition.limit }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_PAGINATION, { content })
          resolve(content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION)
    },
    resetState({commit}) {
      commit(types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },

    [types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_RECYCLE_CONVERSION_FACTOR_DETAIL_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
  },
}

export default recycle_conversion_factor_detail
